import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema, getValidationSchema2 } from '@Shared/utils/validationSchema';
import FirstContactFormMeta from './contact/FirstContactFormMeta';
import SecondContactFormMeta from './contact/SecondContactFormMeta';
import { IContactFormMeta } from './contact/ContactFormMeta';

export interface IAddressFormMeta {
  typeAddress: FormInputMeta,
  address: FormInputMeta,
  street: FormInputMeta,
  postcode: FormInputMeta,
  phone1: FormInputMeta,
  phone2: FormInputMeta,
  zone: FormInputMeta,
  city: FormInputMeta,
  state: FormInputMeta,
  fax: FormInputMeta,

  firstContact: IContactFormMeta,
  secondContact: IContactFormMeta,

  // Schema
  schema: any,
}

const AddressFormMeta: IAddressFormMeta = {} as IAddressFormMeta

AddressFormMeta.typeAddress = {
  name: 'typeAddress',
  type: 'select',
  label: 'Type Adresse',
  // placeholder: 'Type Adresse',
  options: [
    {
      label: 'Administrative office',
      value: 'admin-office',
    },
  ],
  validation: yup.string().required(),
};

AddressFormMeta.address = {
  name: 'address',
  type: 'text',
  label: 'Adresse',
  placeholder: 'Adresse',
  validation: yup.string().required(),
};

AddressFormMeta.street = {
  name: 'street',
  type: 'text',
  label: 'Rue',
  placeholder: 'Rue',
  validation: yup.string().required(),
};

AddressFormMeta.postcode = {
  name: 'postcode',
  type: 'text',
  label: 'Boite Postale',
  placeholder: 'Boite Postale',
  validation: yup.string().required(),
};

AddressFormMeta.phone1 = {
  name: 'phone1',
  type: 'text',
  label: '1er Téléphone',
  placeholder: '1er Téléphone',
  validation: yup.string().required(),
};

AddressFormMeta.phone2 = {
  name: 'phone2',
  type: 'text',
  label: '2eme Téléphone',
  placeholder: '2eme Téléphone',
  validation: yup.string().required(),
};

AddressFormMeta.city = {
  name: 'city',
  type: 'select',
  label: 'Ville',
  // placeholder: 'Ville',
  options: [
    {
      label: 'Douala',
      value: 'douala',
    },
  ],
  validation: yup.string().required(),
};

AddressFormMeta.zone = {
  name: 'zone',
  type: 'text',
  label: 'Zone',
  placeholder: 'Zone',
  validation: yup.string().required(),
};

AddressFormMeta.state = {
  name: 'state',
  type: 'text',
  label: 'Etat',
  placeholder: 'Etat',
  validation: yup.string().required(),
};

AddressFormMeta.fax = {
  name: 'fax',
  type: 'text',
  label: 'Fax',
  placeholder: 'Fax',
  validation: yup.string().required(),
};

const mainValidation = getValidationSchema(AddressFormMeta);
const firstContactValidation = getValidationSchema2(FirstContactFormMeta);
const secondContactValidation = getValidationSchema2(SecondContactFormMeta);

console.log('Validation: ', AddressFormMeta, FirstContactFormMeta);
const validationSchema = { ...mainValidation, ...firstContactValidation, secondContactValidation };
console.log('SCHEMA: ', validationSchema);

AddressFormMeta.firstContact = FirstContactFormMeta;
AddressFormMeta.secondContact = SecondContactFormMeta;

AddressFormMeta.schema = yup.object().shape(validationSchema);

export default AddressFormMeta;